export default __webpack_public_path__ + "pgnv-assets/2d5c2d6fa85a69ab93c5d4aa0a41bda9.png";